// src/libs/tools/reportWebVitals.ts
import { Metric } from 'web-vitals';

export default function reportWebVitals(metric: Metric) {
  const body = JSON.stringify(metric);
  const url = '/api/web-vitals';

  if (process.env.NODE_ENV === 'production') {
    // Utiliser sendBeacon pour éviter de bloquer le thread principal
    if (navigator.sendBeacon) {
      navigator.sendBeacon(url, body);
    } else {
      fetch(url, {
        body,
        method: 'POST',
        keepalive: true,
        headers: { 'Content-Type': 'application/json' },
      });
    }
  }
}
